import "./Header.scss";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUserDetails } from "../../../services/Store/GetUserDetail/actions";

import { Button, Layout, Drawer, Dropdown, Space, Avatar } from "antd";
import { Link } from "react-router-dom";
import {
  MenuOutlined,
  CloseOutlined,
  UserOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { headerMenu } from "../../../helpers/constant";
import logo from "../../../assets/HOQ-Logo.png";
import { getItem } from "../../../helpers/localStorage";

const { Header } = Layout;

const Headers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = true;
  const user = getItem("HOQ_User");

  const [visible, setVisible] = useState(false);
  const pathname = window.location.pathname;

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const onClickSignIN = () => {
    navigate(`/signin`);
  };

  const onClickSignUP = () => {
    navigate(`/signup`);
  };

  const handleLogout = () => {
    // Implement logout logic here
    localStorage.clear();
    navigate(`/signin`);
  };

  const onChangeProfileDropdown = (e) => {
    if (e === "logout") {
      localStorage.clear();
      window.location.reload();
      navigate("/signin");
    }
  };

  const userMenuItems = [
    {
      key: "my-account",
      label: (
        <div className="flex mt-3">
          <Avatar
            className="bg-primary mr-5"
            size={{
              xs: 46,
              sm: 46,
              md: 46,
              lg: 56,
              xl: 56,
              xxl: 64,
            }}
          >
            {user?.first_name[0]?.toUpperCase()}
          </Avatar>
          <div>
            <div className="font-semibold">
              {user?.first_name} {user?.last_name}
            </div>
            <div className="text-primaryGray my-1">{user?.email}</div>
            <div>
              <Button
                onClick={() => {
                  navigate("/profile");
                }}
                type="primary"
                disabled
                className="mt-2 mb-2"
              >
                Edit Profile
              </Button>
            </div>
          </div>
        </div>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "your-exams",
      label: (
        <div
          className="flex items-center "
          onClick={() => onChangeProfileDropdown("your-exams")}
        >
          <i className="icon-your-exams text-[26px] mr-3 text-primary" />
          <div>Your Exam</div>
        </div>
      ),
    },
    {
      key: "applied-jobs",
      label: (
        <div
          className="flex items-center "
          onClick={() => onChangeProfileDropdown("applied-jobs")}
        >
          <i className="icon-jobs text-[26px] mr-3 text-primary" />
          <div>Applied Jobs</div>
        </div>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      label: (
        <div
          className="flex items-center  text-red-500"
          onClick={() => onChangeProfileDropdown("logout")}
        >
          <i className="icon-logout text-[26px] mr-3 " />
          <div>Log Out</div>
        </div>
      ),
    },
  ];

  const onClickLogo = () => {
    navigate("/");
  };

  const renderMenu = () => (
    <>
      {headerMenu?.map((menu) => {
        const isActive =
          pathname === menu?.path || (menu?.path === "/" && pathname === "");
        return (
          <Link
            to={menu?.path}
            key={menu?.path}
            className="my-5 xl:my-0 text-gray-500 text-base"
          >
            <span
              className={`mx-4 px-6 py-3 ${
                isActive ? "text-white bg-primary rounded-full" : ""
              }`}
            >
              {menu?.title}
            </span>
          </Link>
        );
      })}
    </>
  );

  const renderAuthenticatedHeader = () => (
    <div className="header-box flex items-center justify-between w-full h-full py-2  px-header-wrapper">
      <div className="headerLeft flex items-center gap-4">
        <img
          src={logo}
          className="h-[30px] w-[118px] sm:h-auto sm:w-36 lg:h-auto lg:w-48 cursor-pointer"
          alt="Hirequick"
          onClick={onClickLogo}
        />
        
      </div>
      <div className="headerRight flex items-center">
        <Dropdown
          menu={{ items: userMenuItems }}
          placement="bottomRight"
          trigger={["click"]}
          overlayClassName="md:w-[400px] lg:w-[450px] "
          // overlayStyle={{'width':'450px'}}
        >
          <div className="cursor-pointer">
            <Avatar
              className="bg-primary"
              size={{
                xs: 36,
                sm: 36,
                md: 40,
                lg: 40,
                xl: 40,
                xxl: 42,
              }}
            >
              {user?.first_name[0]?.toUpperCase()}
            </Avatar>
            <i className="icon-down-arrow ml-2" />
          </div>
          {/* <Button
            type="text"
            icon={<UserOutlined />}
            className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full hover:bg-gray-100"
          /> */}
        </Dropdown>
      </div>
    </div>
  );

  const renderNonAuthenticatedHeader = () => (
    <div className="header-box flex items-center justify-between w-full h-full py-2 px-4 sm:px-6">
      <div className="headerLeft flex items-center">
        <img
          src={logo}
          className="h-[30px] w-[118px] sm:h-auto sm:w-36 lg:h-auto lg:w-48 cursor-pointer"
          alt="Hirequick"
          onClick={onClickLogo}
        />
      </div>
      <div className="headerCenter hidden xl:block">{renderMenu()}</div>
      <div className="headerRight flex items-center">
        <div className="hidden sm:flex items-center">
          <Button
            type="primary"
            shape="round"
            size="large"
            className="mr-2 text-sm sm:text-base"
            onClick={onClickSignUP}
          >
            Sign Up
          </Button>
          <Button
            type="text"
            shape="round"
            size="large"
            className="text-sm sm:text-base font-semibold"
            onClick={onClickSignIN}
          >
            Sign In
          </Button>
        </div>
        <Button
          type="text"
          icon={<MenuOutlined />}
          onClick={showDrawer}
          className="xl:hidden ml-auto"
        />
      </div>
    </div>
  );

  return (
    <div className="w-full fixed z-10 h-[60px] xl:h-[8vh]">
      {isAuthenticated
        ? renderAuthenticatedHeader()
        : renderNonAuthenticatedHeader()}

      {/* Drawer for mobile menu - only shown when not authenticated */}
      {!isAuthenticated && (
        <Drawer
          title={<img src={logo} className="h-8 w-auto" alt="Hirequick" />}
          placement="right"
          closable={false}
          onClose={onClose}
          open={visible}
          width="100%"
          bodyStyle={{ padding: 0 }}
          headerStyle={{ borderBottom: "none" }}
          extra={
            <Button type="text" icon={<CloseOutlined />} onClick={onClose} />
          }
        >
          <div className="flex flex-col h-full justify-between">
            <div className="flex flex-col mt-5">{renderMenu()}</div>
            <div className="flex flex-col w-full px-4 self-end">
              <Button
                type="primary"
                shape="round"
                size="large"
                className="mb-2 w-full"
                onClick={onClickSignUP}
              >
                Sign Up
              </Button>
              <Button
                type="text"
                shape="round"
                size="large"
                className="mb-4 w-full"
                onClick={onClickSignIN}
              >
                Sign In
              </Button>
            </div>
          </div>
        </Drawer>
      )}
    </div>
  );
};

export default Headers;
